import React from "react";
import api from "../../api";
import { toast } from "sonner";
import { Ban, ShieldCheck, Clock, Infinity as InfinityIcon, ChevronDown } from "lucide-react";
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem } from "../../components/ui/dropdown-menu";

export const BlockIpControls = ({ ip, blocked, onChanged }) => {
  const doBlock = async (hours) => {
    const reason = window.prompt(`Motivo del blocco per l'IP ${ip} (opzionale):`, "Tentativo di intrusione");
    if (reason === null) return;
    try {
      await api.post("/blocked-ips", { ip, reason, duration_hours: hours || undefined });
      toast.success(hours ? `IP ${ip} bloccato per ${hours} ore` : `IP ${ip} bloccato in modo permanente`);
      onChanged && onChanged();
    } catch (e) { toast.error(e?.response?.data?.detail || "Errore durante il blocco"); }
  };

  const doUnblock = async () => {
    try {
      await api.delete(`/blocked-ips/${ip}`);
      toast.success(`IP ${ip} segnalato come legittimo: accesso ripristinato`);
      onChanged && onChanged();
    } catch { toast.error("Errore durante lo sblocco"); }
  };

  if (blocked) {
    return (
      <button onClick={doUnblock} data-testid={`unblock-${ip}`} className="flex items-center gap-1.5 text-[12px] font-bold text-[#16345c] border border-[#16345c] hover:bg-[#16345c] hover:text-white px-3 py-1.5 rounded-sm transition-colors whitespace-nowrap">
        <ShieldCheck size={13} /> Segna come legittimo
      </button>
    );
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button data-testid={`block-${ip}`} className="flex items-center gap-1.5 text-[12px] font-bold text-red-600 border border-red-300 hover:bg-red-600 hover:text-white px-3 py-1.5 rounded-sm transition-colors whitespace-nowrap">
          <Ban size={13} /> Blocca IP <ChevronDown size={13} />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem data-testid={`block-temp-${ip}`} onClick={() => doBlock(24)} className="gap-2 cursor-pointer"><Clock size={14} /> Blocca 24 ore</DropdownMenuItem>
        <DropdownMenuItem data-testid={`block-perm-${ip}`} onClick={() => doBlock(null)} className="gap-2 cursor-pointer text-red-600"><InfinityIcon size={14} /> Blocca permanente</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
